import {
  Bath,
  Droplets,
  Package,
  PackageOpen,
  RockingChair,
  Shirt,
  ShoppingBasket,
  SoapDispenserDroplet,
  Sparkles,
  SprayCan,
  Zap
} from 'lucide-react';
import { ReactComponent as ArmchairIcon } from '../assets/service-icons/mdi/armchair.svg';
import { ReactComponent as ArrowExpandHorizontalIcon } from '../assets/service-icons/mdi/arrow-expand-horizontal.svg';
import { ReactComponent as AtomIcon } from '../assets/service-icons/mdi/atom.svg';
import { ReactComponent as BasketIcon } from '../assets/service-icons/mdi/basket.svg';
import { ReactComponent as BedKingIcon } from '../assets/service-icons/mdi/bed-king.svg';
import { ReactComponent as BedIcon } from '../assets/service-icons/mdi/bed.svg';
import { ReactComponent as BlanketIcon } from '../assets/service-icons/mdi/blanket.svg';
import { ReactComponent as BroomIcon } from '../assets/service-icons/mdi/broom.svg';
import { ReactComponent as CurtainsIcon } from '../assets/service-icons/mdi/curtains.svg';
import { ReactComponent as DresserIcon } from '../assets/service-icons/mdi/dresser.svg';
import { ReactComponent as EraserIcon } from '../assets/service-icons/mdi/eraser.svg';
import { ReactComponent as FeatherIcon } from '../assets/service-icons/mdi/feather.svg';
import { ReactComponent as HangerIcon } from '../assets/service-icons/mdi/hanger.svg';
import { ReactComponent as HighPileRugIcon } from '../assets/service-icons/mdi/high-pile-rug.svg';
import { ReactComponent as IronBoardIcon } from '../assets/service-icons/mdi/iron-board.svg';
import { ReactComponent as IronIcon } from '../assets/service-icons/mdi/iron.svg';
import { ReactComponent as JacketIcon } from '../assets/service-icons/mdi/jacket.svg';
import { ReactComponent as LingerieIcon } from '../assets/service-icons/mdi/lingerie.svg';
import { ReactComponent as LiquidSpotIcon } from '../assets/service-icons/mdi/liquid-spot.svg';
import { ReactComponent as MattressIcon } from '../assets/service-icons/mdi/mattress.svg';
import { ReactComponent as NeedleIcon } from '../assets/service-icons/mdi/needle.svg';
import { ReactComponent as PaletteIcon } from '../assets/service-icons/mdi/palette.svg';
import { ReactComponent as PillowIcon } from '../assets/service-icons/mdi/pillow.svg';
import { ReactComponent as RobotVacuumIcon } from '../assets/service-icons/mdi/robot-vacuum.svg';
import { ReactComponent as RugIcon } from '../assets/service-icons/mdi/rug.svg';
import { ReactComponent as ScentOffIcon } from '../assets/service-icons/mdi/scent-off.svg';
import { ReactComponent as SheepIcon } from '../assets/service-icons/mdi/sheep.svg';
import { ReactComponent as SleepingBagIcon } from '../assets/service-icons/mdi/sleeping-bag.svg';
import { ReactComponent as SofaIcon } from '../assets/service-icons/mdi/sofa.svg';
import { ReactComponent as SprayBottleIcon } from '../assets/service-icons/mdi/spray-bottle.svg';
import { ReactComponent as TieIcon } from '../assets/service-icons/mdi/tie.svg';
import { ReactComponent as TruckDeliveryIcon } from '../assets/service-icons/mdi/truck-delivery.svg';
import { ReactComponent as TshirtIcon } from '../assets/service-icons/mdi/tshirt.svg';
import { ReactComponent as TumbleDryerIcon } from '../assets/service-icons/mdi/tumble-dryer.svg';
import { ReactComponent as VacuumIcon } from '../assets/service-icons/mdi/vacuum.svg';
import { ReactComponent as WardrobeIcon } from '../assets/service-icons/mdi/wardrobe.svg';
import { ReactComponent as WashingMachineIcon } from '../assets/service-icons/mdi/washing-machine.svg';
import { ReactComponent as WeatherWindyIcon } from '../assets/service-icons/mdi/weather-windy.svg';

export const SERVICE_ICON_OPTIONS = [
  {
    value: 'floor_lift',
    label: 'Подъём на этаж',
    icon: ({ className }) => (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <path d="M4 18h4v-4h4v-4h4V6h4" />
        <path d="M18 6h2v2" />
      </svg>
    ),
    keywords: ['этаж', 'подъем', 'подъём', 'лестница', 'доставка']
  },
  {
    value: 'urgent_order',
    label: 'Срочный заказ',
    icon: Zap,
    keywords: ['срочно', 'срочность', 'молния', 'приоритет', 'заказ']
  },
  {
    value: 'Shirt',
    label: 'Футболка / вещи',
    icon: TshirtIcon,
    keywords: ['одежда', 'рубашка', 'футболка', 'вещи', 'форма', 'текстиль']
  },
  {
    value: 'shirt-classic',
    label: 'Рубашка / сорочка',
    icon: Shirt,
    keywords: ['рубашка', 'сорочка', 'одежда', 'вещи', 'текстиль']
  },
  {
    value: 'jacket',
    label: 'Куртка / пуховик',
    icon: JacketIcon,
    keywords: ['куртка', 'пуховик', 'верхняя одежда', 'одежда']
  },
  {
    value: 'workwear',
    label: 'Спецодежда',
    icon: JacketIcon,
    keywords: ['спецодежда', 'рабочая одежда', 'форма', 'комплект']
  },
  {
    value: 'lingerie',
    label: 'Белье',
    icon: LingerieIcon,
    keywords: ['белье', 'нижнее белье', 'бра', 'трусы', 'текстиль']
  },
  {
    value: 'hanger',
    label: 'Вешалка',
    icon: HangerIcon,
    keywords: ['вешалка', 'плечики', 'гардероб', 'одежда']
  },
  {
    value: 'tie',
    label: 'Галстук',
    icon: TieIcon,
    keywords: ['галстук', 'аксессуар', 'одежда']
  },
  {
    value: 'wardrobe',
    label: 'Шкаф',
    icon: WardrobeIcon,
    keywords: ['шкаф', 'гардероб', 'хранение', 'мебель']
  },
  {
    value: 'BedSingle',
    label: 'Подушки / постель',
    icon: BedIcon,
    keywords: ['подушка', 'подушки', 'белье', 'постель', 'простыня', 'текстиль']
  },
  {
    value: 'pillow',
    label: 'Подушка',
    icon: PillowIcon,
    keywords: ['подушка', 'подушки', 'реставрация подушки', 'пух', 'перо']
  },
  {
    value: 'BedDouble',
    label: 'Одеяла / пледы',
    icon: BedKingIcon,
    keywords: ['одеяло', 'плед', 'покрывало', 'постель', 'большой текстиль']
  },
  {
    value: 'blanket',
    label: 'Одеяло / плед',
    icon: BlanketIcon,
    keywords: ['одеяло', 'плед', 'покрывало', 'одеяльце', 'текстиль']
  },
  {
    value: 'mattress',
    label: 'Матрас / наматрасник',
    icon: MattressIcon,
    keywords: ['матрас', 'наматрасник', 'постель', 'спальный']
  },
  {
    value: 'sleeping-bag',
    label: 'Спальный мешок',
    icon: SleepingBagIcon,
    keywords: ['спальный мешок', 'спальник', 'туризм', 'постель']
  },
  {
    value: 'bath-textile',
    label: 'Полотенца / банный текстиль',
    icon: Bath,
    keywords: ['полотенце', 'полотенца', 'банный', 'ванный', 'халат', 'текстиль']
  },
  {
    value: 'curtains',
    label: 'Шторы',
    icon: CurtainsIcon,
    keywords: ['шторы', 'тюль', 'занавески', 'текстиль', 'окно']
  },
  {
    value: 'rug',
    label: 'Ковер',
    icon: RugIcon,
    keywords: ['ковер', 'ковры', 'палас', 'текстиль']
  },
  {
    value: 'high-pile-rug',
    label: 'Ковер с высоким ворсом',
    icon: HighPileRugIcon,
    keywords: ['высокий ворс', 'длинный ворс', 'шагги', 'ковер', 'ковры']
  },
  {
    value: 'wool',
    label: 'Шерсть',
    icon: SheepIcon,
    keywords: ['шерсть', 'шерстяной', 'овчина', 'ковер']
  },
  {
    value: 'delicate',
    label: 'Деликатные материалы',
    icon: FeatherIcon,
    keywords: ['деликатный', 'деликатные материалы', 'бережный уход', 'текстиль']
  },
  {
    value: 'carpet-overlock',
    label: 'Оверлок ковра',
    icon: NeedleIcon,
    keywords: ['оверлок', 'обработка края', 'шитье', 'ковер']
  },
  {
    value: 'Sofa',
    label: 'Диван',
    icon: SofaIcon,
    keywords: ['диван', 'софа', 'мягкая мебель']
  },
  {
    value: 'sofa-cover',
    label: 'Чехол дивана',
    icon: SofaIcon,
    keywords: ['чехол дивана', 'чехол от дивана', 'мебельный чехол', 'диван']
  },
  {
    value: 'Armchair',
    label: 'Кресло',
    icon: ArmchairIcon,
    keywords: ['кресло', 'стул', 'сиденье', 'мебель']
  },
  {
    value: 'rocking-chair',
    label: 'Стул / мебель',
    icon: RockingChair,
    keywords: ['стул', 'стулья', 'кресло', 'мебель', 'сиденье']
  },
  {
    value: 'dresser',
    label: 'Комод',
    icon: DresserIcon,
    keywords: ['комод', 'мебель', 'ящики', 'интерьер']
  },
  {
    value: 'WashingMachine',
    label: 'Стиральная машина',
    icon: WashingMachineIcon,
    keywords: ['стирка', 'прачечная', 'машина', 'washer', 'laundry']
  },
  {
    value: 'tumble-dryer',
    label: 'Сушка',
    icon: TumbleDryerIcon,
    keywords: ['сушка', 'сушильная машина', 'dryer', 'laundry']
  },
  {
    value: 'BrushCleaning',
    label: 'Щетка',
    icon: BroomIcon,
    keywords: ['химчистка', 'чистка', 'щетка', 'уборка', 'веник']
  },
  {
    value: 'vacuum',
    label: 'Пылесос',
    icon: VacuumIcon,
    keywords: ['пылесос', 'чистка', 'уборка', 'vacuum']
  },
  {
    value: 'robot-vacuum',
    label: 'Робот-пылесос',
    icon: RobotVacuumIcon,
    keywords: ['робот', 'пылесос', 'уборка', 'roomba']
  },
  {
    value: 'iron',
    label: 'Утюг',
    icon: IronIcon,
    keywords: ['утюг', 'глажка', 'пар']
  },
  {
    value: 'iron-board',
    label: 'Гладильная доска',
    icon: IronBoardIcon,
    keywords: ['гладильная доска', 'глажка', 'утюжка']
  },
  {
    value: 'basket',
    label: 'Корзина',
    icon: BasketIcon,
    keywords: ['корзина', 'белье', 'laundry basket', 'сбор']
  },
  {
    value: 'shopping-basket',
    label: 'Короб / корзина',
    icon: ShoppingBasket,
    keywords: ['короб', 'корзина', 'контейнер', 'белье', 'сбор', 'хранение']
  },
  {
    value: 'Droplets',
    label: 'Капли',
    icon: Droplets,
    keywords: ['вода', 'влажная', 'ополаскивание', 'капли']
  },
  {
    value: 'SoapDispenserDroplet',
    label: 'Моющее средство',
    icon: SoapDispenserDroplet,
    keywords: ['моющее', 'средство', 'порошок', 'химия']
  },
  {
    value: 'SprayCan',
    label: 'Спрей',
    icon: SprayCan,
    keywords: ['спрей', 'пятна', 'обработка', 'химия']
  },
  {
    value: 'deep-stain',
    label: 'Глубокое загрязнение',
    icon: LiquidSpotIcon,
    keywords: ['глубокое загрязнение', 'пятно', 'грязь', 'сложное загрязнение']
  },
  {
    value: 'dust-removal',
    label: 'Удаление песка и пыли',
    icon: WeatherWindyIcon,
    keywords: ['песок', 'пыль', 'выбивание', 'обеспыливание']
  },
  {
    value: 'odor-removal',
    label: 'Нейтрализация запаха',
    icon: ScentOffIcon,
    keywords: ['запах', 'нейтрализация', 'дезодорация', 'аромат']
  },
  {
    value: 'ozonation',
    label: 'Озонирование',
    icon: AtomIcon,
    keywords: ['озонирование', 'озон', 'обеззараживание', 'молекула']
  },
  {
    value: 'fringe-whitening',
    label: 'Отбеливание бахромы',
    icon: SprayBottleIcon,
    keywords: ['отбеливание', 'бахрома', 'край ковра', 'обработка']
  },
  {
    value: 'material-removal',
    label: 'Удаление пластилина / слайма',
    icon: EraserIcon,
    keywords: ['пластилин', 'слайм', 'жвачка', 'удаление загрязнений']
  },
  {
    value: 'paint-removal',
    label: 'Удаление чернил / краски',
    icon: PaletteIcon,
    keywords: ['чернила', 'фломастер', 'маркер', 'краска', 'рисунок']
  },
  {
    value: 'delivery',
    label: 'Платная доставка',
    icon: TruckDeliveryIcon,
    keywords: ['доставка', 'машина', 'курьер', 'привезти', 'забрать']
  },
  {
    value: 'furniture-move',
    label: 'Перемещение мебели',
    icon: ArrowExpandHorizontalIcon,
    keywords: ['вытащить из под мебели', 'перемещение', 'мебель', 'сдвинуть', 'достать']
  },
  {
    value: 'Sparkles',
    label: 'Деликатный уход',
    icon: Sparkles,
    keywords: ['деликатно', 'свежесть', 'уход', 'чистота']
  },
  {
    value: 'PackageOpen',
    label: 'Упаковка',
    icon: PackageOpen,
    keywords: ['чехол', 'упаковка', 'мешок', 'сбор']
  },
  {
    value: 'Package',
    label: 'Прочее',
    icon: Package,
    keywords: ['прочее', 'предмет', 'общее']
  }
];

export const SERVICE_ICON_VALUES = SERVICE_ICON_OPTIONS.map((item) => item.value);

export const SERVICE_ICON_MAP = SERVICE_ICON_OPTIONS.reduce((acc, item) => {
  acc[item.value] = item;
  return acc;
}, {});

const SERVICE_ICON_ALIASES = {
  floorlift: 'floor_lift',
  stairs: 'floor_lift',
  staircase: 'floor_lift',
  urgent: 'urgent_order',
  urgentorder: 'urgent_order',
  shirt: 'Shirt',
  tshirt: 'Shirt',
  't-shirt': 'Shirt',
  blouse: 'shirt-classic',
  shirtclassic: 'shirt-classic',
  'shirt-classic': 'shirt-classic',
  bed: 'BedSingle',
  'bed-single': 'BedSingle',
  'bed-queen': 'BedDouble',
  'bed-king': 'BedDouble',
  pillow: 'BedSingle',
  pillows: 'BedSingle',
  blanket: 'BedDouble',
  duvet: 'BedDouble',
  bath: 'bath-textile',
  towel: 'bath-textile',
  towels: 'bath-textile',
  sofa: 'Sofa',
  armchair: 'Armchair',
  rockingchair: 'rocking-chair',
  'rocking-chair': 'rocking-chair',
  broom: 'BrushCleaning',
  brushcleaning: 'BrushCleaning',
  'washing-machine': 'WashingMachine',
  washingmachine: 'WashingMachine',
  shoppingbasket: 'shopping-basket',
  'shopping-basket': 'shopping-basket'
};

export const getServiceIconMeta = (iconName) => {
  const normalized = String(iconName || '').trim();
  if (!normalized) return null;
  return SERVICE_ICON_MAP[normalized] || SERVICE_ICON_MAP[SERVICE_ICON_ALIASES[normalized.toLowerCase()]] || null;
};

export const getServiceIconComponent = (iconName) => {
  return getServiceIconMeta(iconName)?.icon || PackageOpen;
};

export const getServiceIconLabel = (iconName) => {
  return getServiceIconMeta(iconName)?.label || 'Услуга';
};
